import { useState, useEffect } from "react";

function useDevice(id) {
  const [device, setDevice] = useState({});
  const [isDeviceLoading, setIsDeviceLoading] = useState(true);

  useEffect(() => {
    const fetchDevice = async () => {
      try {
        setIsDeviceLoading(true);
        const { data } = await window.axiosIns(`/device`, {
          params: { oro_id: id },
        });

        setDevice(data.data);
      } catch (err) {
        console.log(err);
      } finally {
        setIsDeviceLoading(false);
      }
    };

    if (id) {
      fetchDevice();
    }
  }, [id]);

  return { device, isDeviceLoading };
}

export default useDevice;
